import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { showLoader, hideLoader } from '../store/loaderSlice';

interface LoaderMethods {
  showLoader: (message?: string) => void;
  hideLoader: () => void;
}

export const useLoader = (): LoaderMethods => {
  const dispatch = useDispatch();

  const showLoaderFn = useCallback((message?: string) => {
    dispatch(showLoader(message));
  }, [dispatch]);

  const hideLoaderFn = useCallback(() => {
    dispatch(hideLoader());
  }, [dispatch]);

  return {
    showLoader: showLoaderFn,
    hideLoader: hideLoaderFn,
  };
};

